import content from './serviceAreaContent.json';
import { SERVICE_AREA_COUNTIES, type ServiceAreaCounty } from './serviceArea';

export const SERVICE_AREA_LINKS = SERVICE_AREA_COUNTIES.map(county => ({ county, slug: `${county.toLowerCase()}-county-nc`, href: `/service-areas/${county.toLowerCase()}-county-nc` }));
export type ServiceAreaPage = typeof content[number];
export const SERVICE_AREA_PAGES: ServiceAreaPage[] = SERVICE_AREA_COUNTIES.map(county => {
  const page = content.find(item => item.county === county);
  if (!page) throw new Error(`Missing reviewed service-area content: ${county}`);
  return page;
});
export function getServiceAreaPage(slug: string | undefined) {
  return SERVICE_AREA_PAGES.find(page => page.slug === slug);
}
export function getServiceAreaHead(path: string) {
  if (path === '/service-areas') return { title: 'Our North Carolina Service Areas | EZ Septic Pros', description: 'Explore our nine-county North Carolina service area, with local septic resources, permitting contacts and ways to request service.' };
  const page = getServiceAreaPage(path.startsWith('/service-areas/') ? path.slice('/service-areas/'.length) : undefined);
  return page ? { title: `Septic Services in ${page.county} County, NC | EZ Septic Pros`, description: `Septic pumping, inspections, repairs and installation inquiries in ${page.county} County, NC. Local homeowner guidance and official county septic resources.` } : undefined;
}
export function serviceAreaHref(county: ServiceAreaCounty) { return `/service-areas/${county.toLowerCase()}-county-nc`; }
